import { lowerFirst, mapKeys, mapValues, omit } from 'lodash';

import { PendingChangesTypeToHistoryTypeMap } from 'constants/pendingChanges';
import { jsonParse } from 'utils/json';

import { otherExpensesModifiedFieldsToExclude } from '../PropertyExpenses.constants';

export const extractOtherExpensesPendingChangesFromJson = ({ pendingChanges, applicationData }) => {
  const { initialValue } = pendingChanges;

  const parseJsonArray = jsonData =>
    jsonParse(jsonData).map(item => mapKeys(item, (__, key) => lowerFirst(key)));

  const parsedInitialValue = initialValue ? parseJsonArray(initialValue) : [];

  return applicationData?.reduce((acc, data) => {
    acc[data.id] = mapValues(omit(data, otherExpensesModifiedFieldsToExclude), (value, key) => {
      const initialValueItem = parsedInitialValue.find(({ id }) => id === data.id) || {};
      const actionType =
        PendingChangesTypeToHistoryTypeMap[data.pendingChangesActionType] ??
        data.pendingChangesActionType;

      return {
        newValue: value,
        initialValue: initialValueItem?.[key] ?? null,
        actionType,
      };
    });

    return acc;
  }, {});
};
